module.exports = __webpack_public_path__ + "img/31-r.6c8fc82a.png";